import type { ResolvedSalesOrder } from "../types/sales";

const round2 = (n: number) => Math.round(Number(n) * 100) / 100;

/** Root discount_code + discount_amount for sales order voucher UI. */
export function getSalesResolvedDiscountDisplay(
  resolved: ResolvedSalesOrder | null | undefined,
  requestedCode?: string
): { code: string; amount: number } {
  const requested = String(requestedCode ?? "").trim();
  if (!resolved) {
    return { code: requested, amount: 0 };
  }

  const items = Array.isArray(resolved.items) ? resolved.items : [];
  const lineCouponTotal = round2(
    items.reduce((s, li) => s + Number(li.discount_on_total_quantity ?? 0), 0)
  );

  let amount = round2(Number(resolved.discount_amount ?? 0));
  if (amount <= 0 && lineCouponTotal > 0) {
    amount = lineCouponTotal;
  }

  const code = String(resolved.discount_code ?? "").trim() || requested;

  return { code, amount };
}

/** When user clears coupon, ignore stale order/resolve values in breakdown. */
export function getSalesOrderDiscountFieldDisplay(args: {
  liveCode?: string;
  resolved?: ResolvedSalesOrder | null;
  savedCode?: string;
  savedAmount?: number;
  userClearedCoupon?: boolean;
}): { code: string; amount: number } {
  if (args.userClearedCoupon) {
    return { code: "", amount: 0 };
  }

  const live = String(args.liveCode ?? "").trim();
  if (live) {
    return getSalesResolvedDiscountDisplay(args.resolved, live);
  }

  const savedCode = String(args.savedCode ?? "").trim();
  const savedAmount = round2(Number(args.savedAmount ?? 0));
  if (savedCode || savedAmount > 0) {
    return { code: savedCode, amount: savedAmount };
  }

  return getSalesResolvedDiscountDisplay(args.resolved);
}
